export const FIRM = {
  name: "Aniruddha Sonar & Associates",
  designation: "Chartered Accountants",
  phone: "9518759333",
  phoneDisplay: "+91 95187 59333",
  phoneIntl: "+919518759333",
  whatsappNumber: "919518759333",
  email: "caaniruddhasonarmumbai@gmail.com",
  emailSecondary: "caaniruddhasonarnashik@gmail.com",
  addressShort: "F-143, Haware Fantasia Business Park, Vashi, Navi Mumbai – 400703",
  addressLines: ["F-143, Haware Fantasia Business Park,", "Vashi, Navi Mumbai – 400703"],
  established: 2024,
  mapsShareUrl: "https://share.google/aeFL3tOw7gNS3x6Wk",
  mapsDirectionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=Haware+Fantasia+Business+Park,+Vashi,+Navi+Mumbai,+Maharashtra+400703",
  mapsEmbedUrl:
    "https://www.google.com/maps?q=Haware+Fantasia+Business+Park,+Sector+30A,+Vashi,+Navi+Mumbai,+Maharashtra+400703&output=embed",
  instagram:
    "https://www.instagram.com/caaniruddhasonarassociates?igsh=MTlwb2g3N3B1dzIycw==",
  linkedin: "https://www.linkedin.com/in/ca-anirudha-sonar/",
};

export const waLink = (message) =>
  `https://wa.me/${FIRM.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  general: "Hello, I would like to enquire about your professional services.",
  consultation:
    "Hello, I would like to book a consultation with Aniruddha Sonar & Associates.",
  service: (serviceName) =>
    `Hello, I would like to enquire about your ${serviceName} services.`,
};

export const TEL_LINK = `tel:${FIRM.phoneIntl}`;
export const MAIL_LINK = `mailto:${FIRM.email}`;

export const FOUNDER = {
  name: "CA. Aniruddha Ashutosh Sonar",
  role: "Founder & Proprietor",
  qualifications: "ACA | B.Com | M.Com",
  membershipYear: 2024,
  experience: "Approximately 3 years",
  photo: "/assets/founder-aniruddha-sonar.jpg",
  linkedin: FIRM.linkedin,
  focus: [
    "AI-Driven CA Practice",
    "Direct Taxation",
    "GST & Indirect Taxation",
    "Startup Advisory",
    "Business Advisory",
    "Audit & Assurance",
    "Bank Audits",
    "RERA Advisory & Compliance",
    "NRI Taxation",
    "International Taxation",
    "FEMA & Cross-Border Tax Matters",
    "Accounting & MIS Advisory",
    "Corporate & Regulatory Compliance",
    "Virtual CFO & Financial Advisory",
  ],
};
